import React, { useLayoutEffect, useRef, useState } from 'react'
import { Tooltip } from 'antd'
import './style.scss'

const PartNumberLabel = ({
  partNumber,
  dataTestId = 'part-number-label',
  className = '',
  style = null,
}) => {
  const labelRef = useRef(null)
  const [truncated, setTruncated] = useState(false)

  useLayoutEffect(() => {
    if (!labelRef.current) return
    setTruncated(labelRef.current.scrollWidth > labelRef.current.clientWidth)
  }, [partNumber])

  if (!partNumber) return null

  const label = (
    <div
      ref={labelRef}
      className={`part-number-label ${className}`.trim()}
      data-testid={dataTestId}
      style={style}
    >
      {`P/N: ${partNumber}`}
    </div>
  )

  if (!truncated) return label

  return (
    <Tooltip title={`P/N: ${partNumber}`} placement="top">
      {label}
    </Tooltip>
  )
}

export default PartNumberLabel
